export default [
  {
    path: '/banner/:bannerType',
    component: () => import('@/views/operation/bannerList.vue')
  }
];
